// Authentication hooks

import { useContext } from 'react';
import { AuthContext } from './context';

/**
 * Hook to use auth context
 * @throws Error if used outside of AuthProvider
 */
export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
